import * as tslib_1 from "tslib";
import { SearchesCommon } from '../searches.common';
import { SearchEngineTypeValue } from 'modules/shared/models/screening.models';
var SearchesArtemiscanComponent = /** @class */ (function (_super) {
    tslib_1.__extends(SearchesArtemiscanComponent, _super);
    function SearchesArtemiscanComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.searchEngine = SearchEngineTypeValue.ARTEMISCAN;
        _this.isActive = 'alias';
        _this.isLoading = false;
        _this.displayedColumns = ['checkbox', 'name', 'alias', 'list', 'concatAl', 'matched'];
        return _this;
    }
    return SearchesArtemiscanComponent;
}(SearchesCommon));
export { SearchesArtemiscanComponent };
